<template>
  <UserLayout>
    <div
      class="md:px-8 px-4 md:ml-20 md:mt-16 mt-24 pb-24 flex justify-center items-center"
    >
      <!-- <div style="min-height:220px; width: 100%; max-width:500px;">
        <groovesell-embed
          subdomain="fitclasstest"
          checkout="a2a1917ae47b7c9f884bd2ef560563d3"
        >
        </groovesell-embed>
      </div> -->
      <!-- Fitclass paid signup widget -->
      <div
        style="min-height: 220px; width: 100%; max-width: 500px"
        v-if="
          (getToken() && localUser && localUser.user_type != GUEST) || token
        "
      >
        <!-- <link
          href="https://fitclass.groovesell.com/embed/css/app.css?n=1"
          rel="stylesheet"
        /> -->
        <groovesell-embed
          subdomain="fitclass"
          checkout="a3a9f95a123df5714509d0d7304fb97b"
        >
        </groovesell-embed>
        <!-- <script src="https://fitclass.groovesell.com/embed/js/app.js?n=1"></script> -->
      </div>
      <!-- Fitclass guest signup widget -->
      <div style="min-height: 220px; width: 100%; max-width: 500px" v-else>
        <!-- <link
          href="https://fitclass.groovesell.com/embed/css/app.css?n=1"
          rel="stylesheet"
        /> -->
        <groovesell-embed
          subdomain="fitclass"
          force-price="49"
          checkout="7129c0900be7b5afa006d6dbaf0bee14"
        >
        </groovesell-embed>
        <!-- <script src="https://fitclass.groovesell.com/embed/js/app.js?n=1"></script> -->
      </div>
    </div>
  </UserLayout>
</template>

<script>
import UserLayout from "@/components/layouts/UserLayout";

export default {
  name: "AddMoney",
  components: {
    UserLayout,
  },
  data() {
    return {
      localUser: JSON.parse(localStorage.getItem("user")),
    };
  },
};
</script>